import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import MultiRangeSlider from "../../../Components/MultiRangeSlider";
const RejectedRequests = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
              <div className="container px-0">
                <h4 className="event-alert mt-2 br-btm-0">Rejected Requests</h4>

                <div class="row mx-0">
                  <div class="shadowclass top_filters orderpayy mt-0 mb-3">
                    <h4 class="event-alert py-0 my-2">Filters </h4>
                    <div className="row mx-0">
                      <div class="col-lg-4 col-md-6 pl0 px-0 px-sm-3">
                        <div class="calander d-flex align-items-center">
                          <div class="datePicker pading_right">
                            <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="from_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-01"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div>
                          </div>
                          <div class="datePicker pading_lect">
                            <div class="input-append bootstrap-timepicker date-input datepicker2 date">
                              <input
                                name="to_date"
                                class=" "
                                required="required"
                                type="text"
                                id=""
                                value="2022-05-13"
                              />
                              <span class="add-on">
                                <i class="fa fa-calendar"></i>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-6 timing-duration pt-4 pt-sm-0">
                        <MultiRangeSlider
                          min={0}
                          max={1000}
                          onChange={({ min, max }) =>
                            console.log(`min = ${min}, max = ${max}`)
                          }
                        />

                        {/* <span id="time" className="d-flex justify-content-between"><span className="col">12:00 AM</span> - <span className="col align-right">11:59 PM</span></span>

                    <input
                      type="hidden"
                      name="start_time"
                      value="12:00 AM"
                      class="start_time"
                    />
                    <input
                      type="hidden"
                      name="end_time"
                      value="11:59 PM"
                      class="end_time"
                    />

                    <div
                      id="slider-range"
                      class="ui-slider ui-slider-horizontal ui-widget ui-widget-content ui-corner-all"
                      aria-disabled="false"
                    >
                      <div class="ui-slider-range ui-widget-header ui-corner-all"></div>
                      <a
                        class="ui-slider-handle ui-state-default ui-corner-all"
                        href="#"
                      ></a>
                      <a
                        class="ui-slider-handle ui-state-default ui-corner-all"
                        href="#"
                      ></a>
                    </div> */}
                      </div>
                      <div class="selecters col-lg-5 col-md-10 pl-md-0 row mx-0 justify-content-between pt-0 pt-lg-0">
                        <div class="select-div col px-1 pl-md-0">
                          <div class="input select">
                            <select
                              name="waste_group"
                              class="csutom_select"
                              id="WasteWasteGroup"
                            >
                              <option value="">Waste Group</option>
                              <option value="28">Food R&amp;D</option>
                            </select>
                          </div>{" "}
                        </div>
                        <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="waste_type"
                              class="csutom_select"
                              id="WasteWasteType"
                            >
                              <option value="">Waste Type</option>
                              <option value="1">Waste Cost</option>
                              <option value="2">Waste Return</option>
                            </select>
                          </div>{" "}
                        </div>
                        <div class="select-div col px-1">
                          <div class="input select">
                            <select
                              name="supplier"
                              class="csutom_select"
                              id="WasteSupplier"
                            >
                              <option value="">Supplier</option>
                              <option value="6178">6 Drunk Men Pte Ltd</option>
                            </select>
                          </div>{" "}
                        </div>
                      </div>
                      <div class="col-lg-1 col px-0 pt-3 pt-lg-0">
                        <button class="btn btn_btnblue" type="submit">
                          Search
                        </button>
                      </div>
                    </div>
                  </div>{" "}
                </div>
                <div className="accordion" id="accordionPanelsStayOpenExample">
                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingNine2"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseNine2"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseNine2"
                      >
                        <div className="col d-flex align-items-center justify-content-between">
                          <h4 className="event-alert p-0 mb-0">
                            Rejected Leaves
                          </h4>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseNine2"
                      className="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingNine2"
                    >
                      <div className="row mx-0">
                        <div className="container px-0">
                          <div className="shadowclass mt-0">
                            <div className="row justify-content-between align-items-center">
                              <div className="col-md-4">
                                <div className="search-box mt-0">
                                  <form type="GET">
                                    <input
                                      type="text"
                                      placeholder="Search"
                                      name="keyword1"
                                    />
                                    <input type="submit" />
                                  </form>
                                </div>
                              </div>
                            </div>
                            <div class="table-responsive">
                              <table
                                width="100%"
                                cellspacing="0"
                                cellpadding="0"
                                class="checklist-table inventory_table"
                              >
                                <thead>
                                  <tr>
                                    <th> </th>
                                    <th> Requester </th>
                                    <th> Status </th>
                                    <th> Account </th>
                                    <th> Leave Type </th>
                                    <th>
                                      Start Date <br /> &amp; Time
                                    </th>
                                    <th>
                                      End Date <br /> &amp; Time
                                    </th>
                                    <th> Total Days </th>
                                    <th> Request Date </th>
                                    <th> Actions </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr class="order_row bg-gry">
                                    <td class="avtar_pic">
                                      <figure>
                                        <img
                                          src="/img/../employee_images/1642043133.png"
                                          id="preview"
                                          alt=""
                                        />
                                      </figure>
                                    </td>
                                    <td>
                                      <b>Cynthia Boxer</b> <br /> Server
                                    </td>
                                    <td>
                                      <span class="green_tag">Approved</span>
                                    </td>
                                    <td> Boat Quay Pilot </td>
                                    <td> Annual Leave </td>
                                    <td>
                                      Jan 21, 2022
                                      <br /> 05:00am
                                    </td>
                                    <td>
                                      Jan 22, 2022
                                      <br /> 04:59am
                                    </td>
                                    <td> 1 </td>
                                    <td> Jan 20, 2022 </td>
                                    <td>
                                      <a
                                        class="circle_icon"
                                        href="/labor_Settings/leave_claim_details/251"
                                      >
                                        <i class="iconSprites eye-icon">
                                          <div class="tooltip-sm">View</div>
                                        </i>
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2
                      className="accordion-header"
                      id="panelsStayOpen-headingNine3"
                    >
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#panelsStayOpen-collapseNine3"
                        aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseNine3"
                      >
                        <div className="col d-flex align-items-center justify-content-between">
                          <h4 className="event-alert p-0 mb-0">
                            Rejected Claims
                          </h4>
                        </div>
                      </button>
                    </h2>
                    <div
                      id="panelsStayOpen-collapseNine3"
                      className="accordion-collapse collapse show"
                      aria-labelledby="panelsStayOpen-headingNine3"
                    >
                      <div className="row mx-0">
                        <div className="container px-0">
                          <div className="shadowclass mt-0">
                            <div className="row justify-content-between align-items-center">
                              <div className="col-md-4">
                                <div className="search-box mt-0">
                                  <form type="GET">
                                    <input
                                      type="text"
                                      placeholder="Search"
                                      name="keyword1"
                                    />
                                    <input type="submit" />
                                  </form>
                                </div>
                              </div>
                            </div>
                            <div className="table-responsive">
                              <table className="checklist-table remove-space">
                                <thead>
                                  <tr>
                                    <th> </th>
                                    <th> Requester </th>
                                    <th> Status </th>
                                    <th> Account </th>
                                    <th> Claim Type </th>
                                    <th> Total Amounts </th>
                                    <th> Request Date </th>
                                    <th> Attachments </th>
                                    <th> Actions </th>
                                  </tr>
                                </thead>
                                <tbody></tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default RejectedRequests;
